// extracted by css-extract-rspack-plugin
export default {"root":"TableNoRowsPlaceholder_root__XCqdu","message":"TableNoRowsPlaceholder_message__CyjDr","button":"TableNoRowsPlaceholder_button__pVtya"};